import { inject, injectable } from 'inversify';
import {
  InjectionSymbols as LoggerInjectionSymbols,
  type Logger,
} from '@hitiq/logger';
import { AmplifyDataStore } from '../../dataStorePersistence/AmplifyDataStore';
import { ModelTypes } from '../../dataStorePersistence/DataStoreModel';
import { Conneqt, ConneqtBackend } from './conneqt.interfaces';
import { defaultSelectors, defaultDispatchers } from './conneqt.slice';
import { ReduxRepository } from '../reduxRepository';
import { ConneqtTranslator } from './conneqt.translator';
import { createConneqtThunk } from './conneqtCreate.thunk';
import { updateConneqtThunk } from './conneqtUpdate.thunk';
import { deleteConneqtThunk } from './conneqtDelete.thunk';
import { loadConneqtThunk } from './conneqtLoad.thunk';
import { RootState, useAppSelector } from '../../hooks';
import { AccountTypes } from '../../../components/changeUser/accountTypes.enum';

@injectable()
export class ConneqtRepository extends ReduxRepository<
  Conneqt,
  ConneqtBackend
> {
  constructor(
    @inject(LoggerInjectionSymbols.LOGGER)
    protected readonly loggingService: Logger,
    protected readonly datastore: AmplifyDataStore<ConneqtBackend>,
  ) {
    super(
      ModelTypes.Conneqt,
      new ConneqtTranslator(),
      datastore,
      loggingService,
      defaultSelectors,
      defaultDispatchers,
      createConneqtThunk,
      updateConneqtThunk,
      deleteConneqtThunk,
      loadConneqtThunk,
    );
  }

  useClinicConneqtSelector = () => {
    return useAppSelector((state: RootState) => {
      return this.selectors
        .resourcesSelector(state)
        .filter(
          (conneqt) => conneqt.responseAccountType === AccountTypes.Clinic,
        );
    });
  };
}
